/*! Wi-qa - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

+function ($) {
    'use strict';
    var wiQa = window.wiQa;
    window.wiQa = {
        init: function () {
            wiQa.events();
        },
        refresh: function () {
        },
        events: function () {
            $(document).on('show.bs.collapse', '.panel-collapse', function () {
                $(this).siblings('.panel-heading').addClass('active');
            });

            $(document).on('hide.bs.collapse', '.panel-collapse', function () {
                $(this).siblings('.panel-heading').removeClass('active');
            });
            $(document).on('shown.bs.collapse', '.panel-qa', function () {
                wiLayout.scroll.to($(this));
                var id = $(this).attr('id');
                
                $('.panel-qa').each(function () {
                    if (id !== $(this).attr('id')) {
                        $(this).find('.collapse.in').collapse('hide');
                        
                    }
                });
            });
        },
        slideDown: function (th, parent) {
            th.removeClass('loading');
            parent.children('.panel-excerpt').slideUp(400, function () {
                parent.children('.panel-collapse').slideDown(700, function () {
                    wiLayout.scroll.to(parent);
                    wiImages.refresh();
                    wiPlugins.refresh();
                    $(window).trigger('resize');
                });
            });
        }
    };
    $(function () {
        wiQa = window.wiQa;
        wiQa.init();
    });
}(jQuery);
